module.exports = __webpack_public_path__ + "img/logo_l.ca539c50.png";